// Flagged years — the study list on Yearly Statistics (Apal, 2026-09-24):
// years where the strategy failed the year badly enough that someone should
// sit down with them later. Amber, not red: these are "investigate" markers,
// never act-now alarms, and they must stay RARE to stay meaningful.
//
// Thresholds were fitted against the full dataset (446 index-years, 18
// symbols, 2026-09-24): this set flags 14 years (3%) — a real study list.
// 'deep loss' has ZERO historical occurrences; it exists as a tripwire.
export const FLAG_RULES = {
  rally_index_min: 15,   // an index year counts as a rally at +15% or more
  rally_capture_max: 0.25, // flagged when the strategy took under a quarter of it
  deep_loss: -15,        // flagged when the strategy itself lost 15%+
  worse_gap_pts: 3,      // down year: flagged when trailing the index by >3pts
};

// One flag per year, first match wins — ordered by severity: losing more than
// buy-&-hold is the worst failure (the strategy's pitch is downside
// protection), a deep loss is next, a missed rally is the mildest.
export function flagYear(y) {
  const s = y?.strategy_return;
  const i = y?.index_return;
  if (s == null) return null;
  if (i != null && i < 0 && s < i - FLAG_RULES.worse_gap_pts) {
    return {
      reason: 'worse than holding',
      sentence: `A down year where the strategy lost more than simply holding the index ` +
        `(${fmt(s)} vs ${fmt(i)}) — downside protection failed.`,
    };
  }
  if (s <= FLAG_RULES.deep_loss) {
    return {
      reason: 'deep loss',
      sentence: `The strategy itself lost ${fmt(s)} — beyond the ${FLAG_RULES.deep_loss}% study threshold.`,
    };
  }
  if (i != null && i >= FLAG_RULES.rally_index_min && s < i * FLAG_RULES.rally_capture_max) {
    return {
      reason: 'missed the rally',
      sentence: `The index gained ${fmt(i)} but the strategy captured only ${fmt(s)} — ` +
        `under a quarter of a ${FLAG_RULES.rally_index_min}%+ rally.`,
    };
  }
  return null;
}

const fmt = (v) => `${v > 0 ? '+' : ''}${v.toFixed(2)}%`;

// year -> flag for a whole series, skipping the running year (it isn't a
// verdict yet — a mid-year lag is not a study item until the year closes)
export function flagYears(yearly, currentYear) {
  const out = {};
  (yearly || []).forEach((y) => {
    if (currentYear != null && y.year >= currentYear) return;
    const f = flagYear(y);
    if (f) out[y.year] = f;
  });
  return out;
}
